import axios from "axios";
import accessToken from "./jwt-token-access/accessToken";

//pass new generated access token here
const token = accessToken;

//apply base url for axios
const API_URL = "";

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.defaults.headers.common["Authorization"] = token;

axiosApi.interceptors.request.use(
  config => {
    let accessToken = localStorage.getItem("access_token")
    if (!accessToken) {
      const tokenVal = localStorage.getItem("Token")
      if (tokenVal) {
        try {
          accessToken = JSON.parse(tokenVal)
        } catch (e) {
          accessToken = tokenVal
        }
      }
    }
    if (accessToken) {
      config.headers = config.headers || {}
      const hasAuth = Object.keys(config.headers).some(
        key => key.toLowerCase() === "authorization"
      )
      if (!hasAuth) {
        config.headers["Authorization"] = `Bearer ${accessToken}`
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
